<template>
  <section>
    <button
      v-if="!readonly"
      class="btn btn-success btn-sm float-right m-1"
      type="button"
      @click="modalAdd"
    >
      <CIcon size="sm" name="cil-plus" />
    </button>
    <CDataTable
      class="table-bordered c-table c-table-items"
      :hover="true"
      :striped="true"
      :bordered="true"
      :small="true"
      :items="items"
      :fields="fields"
      :loading="loading"
    >
      <template #no-items-view>
        <div class="text-center">
          <span>
            {{ loading ? "Cargando datos..." : "Orden de trabajo vacia." }}
          </span>
        </div>
      </template>
      <template #index="{ index }">
        <td>{{ index + 1 }}</td>
      </template>
      <template #unit_cost="{ item }">
        <td class="text-right">
          {{ item.unit_cost | currency }}
        </td>
      </template>

      <template #total_cost="{ item }">
        <td class="text-right">
          {{ (item.quantity * item.unit_cost) | currency }}
        </td>
      </template>
      <template #detail="{ item }">
        <td v-if="!readonly">
          <b-button-group size="xs">
            <b-button
              @click="modalEdit(item.id)"
              variant="warning"
              title="Editar"
            >
              <CIcon size="sm" name="cil-pencil" />
            </b-button>
            <b-button
              @click="modalDelete(item.id)"
              variant="danger"
              title="Eliminar"
            >
              <CIcon size="sm" name="cil-trash" />
            </b-button>
          </b-button-group>
        </td>
      </template>
      <template #footer>
        <tfoot>
          <td colspan="3"></td>
          <td><b>Total</b></td>
          <td class="text-right">
            <b> Bs. {{ totalItems | currency }}</b>
          </td>
          <td v-if="!readonly"></td>
        </tfoot>
      </template>
    </CDataTable>
    <section v-if="modShowSaleItemAdd">
      <SaleItemAddModal
        :sale_id="sale_id"
        :modShowSaleItemAdd="modShowSaleItemAdd"
        @saleItemAddModal="afterSaleItemAddModal"
      ></SaleItemAddModal>
    </section>

    <section v-if="modShowSaleItemEdit">
      <SaleItemEditModal
        :sale_item_id="sale_item_id"
        :modShowSaleItemEdit="modShowSaleItemEdit"
        @saleItemEditModal="afterSaleItemEditModal"
      ></SaleItemEditModal>
    </section>
    <section v-if="modShowSaleItemDelete">
      <SaleItemDeleteModal
        :sale_item_id="sale_item_id"
        :modShowSaleItemDelete="modShowSaleItemDelete"
        @saleItemDeleteModal="afterSaleItemDeleteModal"
      ></SaleItemDeleteModal>
    </section>
  </section>
</template>
<script>
import { BButton, BButtonGroup } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
// services
import SalesItems from "@/plugins/services/sales-items";
//components
import SaleItemAddModal from "@/entities/sales-items/SaleItemAddModal";
import SaleItemEditModal from "@/entities/sales-items/SaleItemEditModal";
import SaleItemDeleteModal from "@/entities/sales-items/SaleItemDeleteModal";

export default {
  name: "SalesItemsList",
  components: {
    BButton,
    BButtonGroup,
    SaleItemAddModal,
    SaleItemEditModal,
    SaleItemDeleteModal,
  },
  props: {
    sale_id: {
      default: null,
    },
    readonly: {
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "#",
          filter: false,
        },
        {
          key: "item_name",
          label: "Item",
          filter: false,
        },
        {
          key: "quantity",
          label: "Cantidad",
          _classes: "text-right",
          filter: false,
        },
        {
          key: "unit_cost",
          _classes: "text-right",
          label: "Costo Unitario",
          filter: false,
        },

        {
          key: "total_cost",
          label: "Importe Total (Bs.)",
          _classes: "text-right",
          filter: false,
        },
        {
          key: "detail",
          _classes: "text-center",
          _style: "width:100px;",
          label: "",
          filter: false,
        },
      ],
      items: [],
      columnFilter: {
        draft: true,
        column: "created_at",
        asc: false,
      },
      page: 0,
      pages: 0,
      limit: 100,
      from: 0,
      to: 0,
      total: 0,
      sale_item_id: 0,
      modShowSaleItemDelete: false,
      modShowSaleItemEdit: false,
      modShowSaleItemAdd: false,
      totalItems: 0,
    };
  },
  created() {
    if (this.readonly) {
      this.fields = this.fields.filter(function (field) {
        return field.key !== "detail";
      });
    }
    this.getItems(this.sale_id);
  },
  watch: {},
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      SalesItems.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.total = res.data.total;
        this.calculateTotal();
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    getItems(sale_id) {
      this.columnFilter.sale_id = sale_id;
      this.getAll(this.columnFilter);
    },
    clean() {
      this.getAll(this.columnFilter);
    },
    calculateTotal() {
      var _this = this;
      var total = 0;
      this.items.forEach(function (item) {
        total += item.unit_cost * item.quantity;
      });
      this.totalItems = total.toFixed(2);
      this.$emit("salesItemsList", {
        totalItems: parseFloat(this.totalItems),
        countItems: this.total,
      });
    },
    modalDelete(id) {
      this.modShowSaleItemDelete = true;
      this.sale_item_id = id;
    },
    afterSaleItemDeleteModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.clean();
      }
      this.modShowSaleItemDelete = response.modalShow;
    },
    //modal edit
    modalEdit(id) {
      this.modShowSaleItemEdit = true;
      this.sale_item_id = id;
    },
    afterSaleItemEditModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.clean();
      }
      this.modShowSaleItemEdit = response.modalShow;
    },
    //modal edit
    modalAdd() {
      this.modShowSaleItemAdd = true;
    },
    afterSaleItemAddModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.clean();
      }
      this.modShowSaleItemAdd = response.modalShow;
    },
  },
};
</script>